export default {
  title: {
    list: '站内消息',
    detail: '消息详情'
  },
  label: {
    notification: '站内消息',
    read: '已读',
    unread: '未读'
  },
  button: {
    return: '返回'
  }
}
